import $ from "jquery";

//console.log('accept payment custom scripts');
